import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import apis from "../../../../api/api.actions";
import Snackbar from "../../../../components/snackbar/snackbar";
import "./style.css";

function ResetPasswordModal({ show, onHide, token }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [closeOnSnackOk, setCloseOnSnackOk] = useState(false);

  useEffect(() => {
    if (!show) return;
    setCurrentPassword("");
    setNewPassword("");
    setNewPasswordConfirmation("");
    setSubmitting(false);
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    setCloseOnSnackOk(false);
  }, [show]);

  const openSnack = (message, isError, shouldCloseOnOk = false) => {
    setSnackMessage(message || "");
    setIsSnackError(Boolean(isError));
    setCloseOnSnackOk(Boolean(shouldCloseOnOk));
    setSnackOpen(true);
  };

  const handleSubmit = async () => {
    if (submitting) return;

    if (!currentPassword || !newPassword || !newPasswordConfirmation) {
      openSnack("Please fill all fields.", true);
      return;
    }
    if (newPassword !== newPasswordConfirmation) {
      openSnack("New password and confirmation do not match.", true);
      return;
    }

    try {
      setSubmitting(true);
      const res = await apis.createData(
        "company/update-password",
        {
          current_password: currentPassword,
          new_password: newPassword,
          new_password_confirmation: newPasswordConfirmation,
        },
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
      );

      openSnack(
        res?.message || res?.data?.message || "Password updated successfully.",
        false,
        true
      );
    } catch (err) {
      console.error("Update password failed:", err);
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Update password failed. Please try again.";
      openSnack(String(msg), true, false);
    } finally {
      setSubmitting(false);
    }
  };

  const snackbarClose = (isError) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!isError && closeOnSnackOk) onHide?.();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        centered
        dialogClassName="reset-pass-modal"
        contentClassName="modal-content-reset"
        backdrop="static"
      >
        <div className="p-[20px]">
          <div className="">
            <button
              type="button"
              className="reset-pass-close"
              onClick={onHide}
              aria-label="Close"
              disabled={submitting}
            >
              ×
            </button>

            <div className="reset-pass-header">Reset Password</div>

            <div className="reset-pass-body d-flex justify-content-center align-items-center flex-column">
              <div>
                <img src="/resources/img/login/login-avatar.png" alt="" />
              </div>
              <div className="reset-pass-label">
                Enter your current password and new password
              </div>

              <div className="w-100 reset-pass-fields">
                <div className="reset-pass-field mb-2">
                  <label className="reset-pass-field-label">
                    Current Password
                  </label>
                  <input
                    type="password"
                    className="form-control reset-pass-input"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    autoComplete="current-password"
                  />
                </div>

                <div className="reset-pass-field mb-2">
                  <label className="reset-pass-field-label">New Password</label>
                  <input
                    type="password"
                    className="form-control reset-pass-input"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    autoComplete="new-password"
                  />
                </div>

                <div className="reset-pass-field mb-1">
                  <label className="reset-pass-field-label">
                    Confirm New Password
                  </label>
                  <input
                    type="password"
                    className="form-control reset-pass-input"
                    value={newPasswordConfirmation}
                    onChange={(e) => setNewPasswordConfirmation(e.target.value)}
                    autoComplete="new-password"
                  />
                </div>
              </div>
            </div>

            <div className="reset-pass-action">
              <button
                className="reset-pass-button"
                type="button"
                onClick={handleSubmit}
                disabled={submitting}
              >
                {submitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </>
  );
}

export default ResetPasswordModal;
